import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ExtraHoursRangeFragment } from 'generated/resources/graphql'

import Popover from 'modules/core/components/PopoverMenu'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import DeleteRuleModal from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/HoursRules/DeleteRuleModal'
import RuleDetails from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/HoursRules/RuleDetails'
import HoursRulesWizard from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/HoursRulesWizard'
import { useAttendanceSettingWorkCategories } from 'modules/attendance/lib/attendanceSettingWorkCategoriesContext'
import { getTrackingOrigin } from 'modules/attendance/lib/trackingUtils'

interface Props {
  rule: ExtraHoursRangeFragment
}

const CustomRule = ({ rule }: Props) => {
  const [openEditModal, setOpenEditModal] = React.useState(false)
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false)
  const { attendanceSetting } = useAttendanceSettingWorkCategories()

  const handleEditClick = () => {
    setOpenEditModal(true)
    track(trackingEvents.timeTracking.customRuleEditPressed, {
      origin: getTrackingOrigin(rule?.employeeType),
    })
  }

  return (
    <>
      <Box
        gap="s16"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{ all: 'abs016' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        onClick={handleEditClick}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text color="grey1000" size="300" weight="semibold">
            {rule?.timeSettingsCustomTimeRangeCategory?.name}
          </Text>
          <Popover type="list">
            <Popover.Trigger>
              <Button type="secondary" iconName="ellipsis" onClick={(e) => e.stopPropagation()} />
            </Popover.Trigger>
            <Popover.Content side="bottom" align="end">
              <>
                <Popover.TouchableOption
                  title={i18n.t(
                    'time_tracking.settings.work_time_categories.common.rules.custom_rule.edit'
                  )}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleEditClick()
                  }}
                />
                <Popover.TouchableOption
                  title={i18n.t(
                    'time_tracking.settings.work_time_categories.common.rules.custom_rule.delete'
                  )}
                  onClick={(e) => {
                    e.stopPropagation()
                    setOpenDeleteModal(true)
                  }}
                  danger
                />
              </>
            </Popover.Content>
          </Popover>
        </Box>
        <RuleDetails rule={rule} />
      </Box>
      {openEditModal && !openDeleteModal && (
        <HoursRulesWizard onClose={() => setOpenEditModal(false)} extraHourRule={rule} />
      )}
      {openDeleteModal && (
        <DeleteRuleModal
          attendanceSetting={attendanceSetting}
          rule={rule}
          onClose={() => {
            setOpenEditModal(false)
            setOpenDeleteModal(false)
          }}
        />
      )}
    </>
  )
}

export default CustomRule
